import _get from "lodash/get";

import type { AxiosError } from "axios";

export function getErrorDetails(error: AxiosError) {
  return _get(error, "response.data", error);
}
